import { SET_SELECTED_DESTINATION_GHA_ID } from '../actions/actionTypes';

const initialState: number = -1;

export const destinationGhaReducer = (state: number = initialState, action: any) => {
  switch (action.type) {
    case SET_SELECTED_DESTINATION_GHA_ID:
      return action.data;
    default:
     return state;
  };
};